<template>
 <div class="loader hidden">
    <div class="spinner"></div>
  </div>
</template>